import {
  BankAccountOwnerType,
  bankAccountSchema,
  schemes,
  zSchema,
} from "@zeal/common";

const baseCreateBankAccountRequestSchema = zSchema.object({
  account_number: schemes.bankAccountNumber(),
  companyID: schemes.companyID(),
  institution_name: zSchema.string().nullish(),
  nickname: zSchema.string().nullish(),
  is_primary: zSchema.boolean(),
  owner_type: zSchema
    .nativeEnum(BankAccountOwnerType)
    .optional()
    .default(BankAccountOwnerType.Worker),
  type: schemes.bankAccountType(),
  id: schemes.mongoObjectId(),
});

const usCreateBankAccountRequestSchema =
  baseCreateBankAccountRequestSchema.extend({
    routing_number: schemes.routingNumber(),
  });

const canadianCreateBankAccountRequestSchema =
  baseCreateBankAccountRequestSchema.extend({
    transit_number: schemes.transitNumber(),
    institution_number: schemes.institutionNumber(),
  });

export const createBankAccountRequestSchema = zSchema.union([
  usCreateBankAccountRequestSchema,
  canadianCreateBankAccountRequestSchema,
]);

export type TCreateBankAccountRequestSchema = zSchema.infer<
  typeof createBankAccountRequestSchema
>;

export const createBankAccountResponseSchema = bankAccountSchema.extend({
  bankAccountID: schemes.uuid(),
});

export type TCreateBankAccountResponseSchema = zSchema.infer<
  typeof createBankAccountResponseSchema
>;
